<template>
  <svg
    class="svg-icon"
    :style="{
      width: width,
      height: height,
      color: color,
    }"
    aria-hidden="true"
  >
    <use :xlink:href="`#${name}`" :fill="color" />
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true,
      default: '',
    },
    width: {
      type: String,
      default: '1rem',
    },
    height: {
      type: String,
      default: '1rem',
    },
    color: {
      type: String,
      default: '#000',
    },
  },
};
</script>

<style lang="scss">
.svg-icon {
  display: inline-block;
  overflow: hidden;
  width: 1rem;
  height: 1rem;
  fill: currentColor !important;
}
</style>
